import propertyLogo from "../../../assets-user/property.svg";
import beautifulFamilyImg from "../../../assets-user/beautifulFamily.png";
import { useFlowManager } from "../../../hooks/useFlowManager";

const InteriorBanner = () => {
  const { handlePostPropertyClick } = useFlowManager();
  return (
    <div className="w-full px-4 sm:px-6 lg:px-10 pt-6 md:pt-8 lg:pt-10">
      <div className="mx-auto">
        <div className="relative bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl lg:rounded-3xl overflow-hidden shadow-lg">
          <div className="flex flex-col md:flex-row items-center md:items-start justify-between">
            {/* LEFT CONTENT */}
            <div className="w-full md:w-1/2 p-6 space-y-4 sm:space-y-5">
              <h2 className="text-3xl sm:text-[28px] md:text-[32px] lg:text-[36px] font-semibold font-[Poppins] leading-[150%] tracking-[0.01em] text-[#2F2F2F]">
                Make Your Dreams Come True!
              </h2>

              <p className="text-lg sm:text-[18px] md:text-[20px] lg:text-[22px] font-normal font-[Poppins] leading-[150%] tracking-[0.01em] text-[#7D7D7D] w-full xl:w-[85%]">
                Connect with our experts to get personalized assistance for your
                property listing
              </p>

              <button 
                onClick={handlePostPropertyClick}
                className="hidden sm:flex items-center space-x-2 bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-xl transition-all font-medium text-sm shadow-sm"
              >
                <img src={propertyLogo} alt="" className="w-4 h-4" />
                <span>Post Property</span>
              </button>
            </div>

            {/* IMAGE SECTION — Fully Responsive, No px Values */}
            <div className="w-full md:w-1/2 h-full flex justify-center md:justify-end mt-4 md:mt-0">
              <img
                src={beautifulFamilyImg}
                alt="Family"
                className="
                  w-full 
                  h-auto 
                  object-contain md:object-cover
                  rounded-none
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteriorBanner;

// import propertyLogo from "../../../assets-user/property.svg";
// import beautifulFamilyImg from "../../../assets-user/beautifulFamily.png";

// const InteriorBanner = () => {

//   return (
//     <div className="w-full px-4 sm:px-6 lg:px-10 pt-6 md:pt-8 lg:pt-10">
//       <div className="mx-auto">
//         <div
//           className="relative bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl lg:rounded-3xl overflow-hidden shadow-lg"
//           data-aos="fade-up"
//         >
//           <div className="flex flex-col md:flex-row items-start justify-start">
//             {/* Left Content Section */}
//             <div
//               className="w-full md:w-1/2 p-6 space-y-6"
//               data-aos="fade-right"
//             >
//               <h2
//                 className="text-[36px] font-semibold font-[Poppins] leading-[150%] tracking-[0.01em] text-[#2F2F2F] sm:text-[28px] md:text-[32px] lg:text-[36px] mb-1 sm:mb-2 md:mb-3 lg:mb-4"
//                 data-aos="fade-down"
//               >
//                 Make Your Dreams Come True!
//               </h2>
//               <p
//                 className="text-[24px] font-normal font-[Poppins] leading-[150%] tracking-[0.01em] text-[#7D7D7D] sm:text-[18px] md:text-[20px] lg:text-[24px] w-full xl:w-[90%]"
//                 data-aos="fade-up"
//               >
//                 Connect with our experts to get personalized assistance for your
//                 property listing
//               </p>

//               <button
//                 className="hidden lg:flex items-center space-x-2 bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-xl transition-colors font-medium text-sm"
//                 data-aos="zoom-in"
//               >
//                 <img src={propertyLogo} alt="" />
//                 <span>Post Property</span>
//               </button>
//             </div>

//             {/* Image Section */}
//             <div
//               className="hidden md:flex w-full md:w-1/2 relative"
//               data-aos="fade-left"
//             >
//               <img
//                 src={beautifulFamilyImg}
//                 alt=""
//                 className="w-full md:h-[230px] lg:h-[270px] xl:h-[250px]"
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default InteriorBanner;
